import React, { useState } from 'react';
import styled from 'styled-components';
import { login } from '../api/auth';

const LoginContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
`;

const LoginBox = styled.div`
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #000;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;

  &:hover {
    background-color: #333;
  }

  &:disabled {
    background-color: #999;
    cursor: not-allowed;
  }
`;

const ForgotPassword = styled.div`
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #666;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
`;

const StatusMessage = styled.div`
  color: #666;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
`;

interface LoginPageProps {
  onLogin: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username || !password) {
      setError('Vyplňte prihlasovacie meno a heslo');
      return;
    }
    
    setIsLoading(true);
    setError('');
    setStatus('Prihlasujem...');
    
    try {
      const response = await login({ username, password });
      
      if (response.success) {
        setStatus('Úspešné prihlásenie!');
        // Save user info to localStorage for persistence
        localStorage.setItem('user', JSON.stringify(response.user));
        onLogin();
      } else {
        setError(response.message || 'Neúspešné prihlásenie');
        setStatus('');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Chyba pri prihlasovaní');
      setStatus('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginContainer>
      <LoginBox>
        <Title>Prihlásenie</Title>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Používateľské meno</Label>
            <Input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
          </FormGroup>
          <FormGroup>
            <Label>Heslo</Label>
            <Input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </FormGroup>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {status && <StatusMessage>{status}</StatusMessage>}
          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'Prihlasujem...' : 'Prihlásiť'}
          </Button>
          <ForgotPassword>Zabudnuté heslo?</ForgotPassword>
        </form>
      </LoginBox>
    </LoginContainer>
  );
};

export default LoginPage; 